import { useMutation } from '@apollo/client';

import basicUserProfile from '../../../../../graphql/basicUserProfile.graphql';
import createManualPlaidVerificationQuery from '../../../../../graphql/mutations/plaid_verifications/createManualPlaidVerificationMutation.graphql';
import addRenterPaymentMethodQuery from '../../../../../graphql/mutations/renter_payment_methods/addRenterPaymentMethod.graphql';

const useAddRenterPaymentMethod = () => {
  const [addRenterPaymentMethodMutation, { loading }] = useMutation(
    addRenterPaymentMethodQuery,
  );
  const [
    createManualPlaidVerificationMutation,
    { loading: creatingManualPlaidVerification },
  ] = useMutation(createManualPlaidVerificationQuery);

  const addRenterPaymentMethod = async (data) => {
    const res = await addRenterPaymentMethodMutation({
      variables: data,

      refetchQueries: [{ query: basicUserProfile }],
      awaitRefetchQueries: true,
    });
    if (res.data?.addRenterPaymentMethod?.paymentMethod) {
      return res.data.addRenterPaymentMethod.paymentMethod;
    }
  };

  const createManualPlaidVerification = async (data) => {
    const res = await createManualPlaidVerificationMutation({
      variables: data,

      refetchQueries: [{ query: basicUserProfile }],
      awaitRefetchQueries: true,
    });
    if (res.data?.createManualPlaidVerificationMutation?.payment_method) {
      return res.data.createManualPlaidVerificationMutation.payment_method;
    }
  };

  return {
    addRenterPaymentMethod,
    adding: loading,
    createManualPlaidVerification,
    creatingManualPlaidVerification,
  };
};

export default useAddRenterPaymentMethod;
